// import * as dotenv from 'dotenv'
import axios from 'axios'
import axiosDefault from './axiosDefault'
// dotenv.config()


const API_URL = process.env.REACT_APP_API_URL
  ;
export const login = (obj) => {
  ;
  return axios.post(API_URL + '/auth/login', obj)
}

export const signUp = (obj) => {
  return axios.post(API_URL + '/users', obj)
}

export const getUserFromStorage = () => {
  return JSON.parse(localStorage.getItem('user'))
}

export const getUserByCode = (code) => {
  return axiosDefault.get(API_URL + `/users/code/${code}`)
}


export const getUsercode = (id) => {
  return axiosDefault.get(API_URL + `/users/${id}/codes`)
}

export const getUsercodeKeys = () => {
  return axiosDefault.get(API_URL + `/users/code-keys`)
}



export const getUserApiToken = () => {
  return axiosDefault.get(API_URL + `/users/apikeytkn`);
}



export const getUserApiSecondaryToken = () => {
  return axiosDefault.get(API_URL + `/users/apikeytkn_secondary`);
}




export const requestForSecondaryTkn = () => {
  return axiosDefault.get(API_URL + `/users/request_sectoken`);
}

export const promoteTokenToPrimary = () => {
  return axiosDefault.get(API_URL + `/users/promote_token`);
}

export const getUserAcountIdByUserId = (id) => {
  return axiosDefault.get(API_URL + `/users/:userId`);
}

export const deleteUserApiSecondaryToken = () => {
  return axiosDefault.delete(API_URL + `/users/apikeytkn_secondary`);
}

// export const getUserByUserId = (id) => {
//   return axios.get(API_URL + `/users/admin/${id}`);
// }

export const getUserByUserId = () => {
  return axiosDefault.get(API_URL + `/users/admin`);
}

export const getUserByUserIdAdmin = (userId) => {
  return axiosDefault.get(API_URL + `/users/admin/${userId}`);
}

export const addBalance = (obj) => {
  return axiosDefault.post(API_URL + '/users/admin/add-balance', obj)
}

export const updateTarrif = (obj) => {

  return axiosDefault.put(API_URL + '/profile/charge-price', obj)
}

export const getUsers = (params) => {
  return axiosDefault.get(API_URL + `/users?pageIndex=${params.current}&pageSize=${params.pageSize}&companyName=${params.searchCompany}&email=${params.searchEmail}&isApproved=${params.isApproved}&type=${params.type}`)
}

export const getAllComapny = (params) => {
  return axiosDefault.get(API_URL + `/profile/admin?pageIndex=${params.current}&pageSize=${params.pageSize}&companyName=${params.searchCompany}&email=${params.searchEmail}&isApproved=${params.isApproved}&type=${params.type}`)
}




export const getUserTransactionLog = async (pagination) => {
  return await axiosDefault.get(API_URL + `/users/transaction-log?pageIndex=${pagination.current}&pageSize=${pagination.pageSize}`)
}

export const getUserTransactionLogForAdmin = async (pagination, userId) => {
  return await axiosDefault.get(API_URL + `/users/transaction-log/${userId}?pageIndex=${pagination.current}&pageSize=${pagination.pageSize}`)
}




export const updatApprovementForAdmin = (body) => {
  return axiosDefault.put(API_URL + `/users/approvement-update`, body)
}






export const verifyOTPCode = (body) => {
  return axios.post(API_URL + `/users/otpcnfph`, body)
}

export const accountApprovement = (body) => {
  return axiosDefault.post(API_URL + `/users/account_approve`, body)
}

export const verifyOTPCodeByEmail = (body) => {
  return axios.post(API_URL + `/users/otpcnfem`, body)
}

export const resendOTPCode = (body) => {
  return axios.post(API_URL + `/users/reotpph`, body)
}
export const verifyOTPCodeForPasswordReset = (body) => {
  return axios.post(API_URL + `/users/verify-otp`, body)
}

export const resendOTPByEmail = (body) => {
  return axios.post(API_URL + `/users/reotpem`, body)
}
export const resendOTPByEmailPassword = (body) => {
  return axios.post(API_URL + `/users/reotpempswd`, body)
}



export const resetPassword = (body) => {
  return axios.post(API_URL + `/users/reset-password`, body)
}

export const updatedPassword = (body) => {
  return axios.post(API_URL + `/users/updated-password`, body)
}

export const changePassword = (body) => {
  return axios.post(API_URL + `/users/change-password`, body)
}

export const queryBuilder = (query) => {
  if (!query) return
  let q = ''
  for (const [key, value] of Object.entries(query)) {
    if (value) q = q + `${key}=${value}&`
  }
  return q
}

export const aAdminResetUserAccount = async (data) => {
  try {
    const response = await axiosDefault.patch(API_URL + "/users/admin/reset-account", data)
    return response.data
  } catch (error) {
    return {
      success: false,
      error: "something went wrong"
    }
  }
}

export const getCallCenterAgents = async () => {
  try {
    const response = await axiosDefault.get(API_URL + "/users/agents")
    return response.data
  } catch (error) {
    return {
      success: false,
      error: "something went wrong"
    }
  }
}

export const registerCallCenterAgent = async (data) => {
  try {
    const response = await axiosDefault.post(API_URL + "/users/agents/register", data)
    return response.data
  } catch (error) {
    return {
      success: false,
      error: "something went wrong"
    }
  }
}

export const blockCallCenterAgentById = async (id) => {
  try {
    const response = await axiosDefault.patch(API_URL + `/users/agents/${id}/block`)
    return response.data
  } catch (error) {
    return {
      success: false,
      error: "something went wrong"
    }
  }
}

export const resetCallCenterAgentPasswordById = async (id) => {
  try {
    const response = await axiosDefault.patch(API_URL + `/users/agents/${id}/reset-password`)
    return response.data
  } catch (error) {
    return {
      success: false,
      error: "something went wrong"
    }
  }
}


export const registerFacilitator = async (data) => {
  try {
    const response = await axiosDefault.post(API_URL + "/users/facilitators/register", data)
    return response.data
  } catch (error) {
    return {
      success: false,
      error: "something went wrong"
    }
  }
}

export const getFacilitators = async () => {
  try {
    const response = await axiosDefault.get(API_URL + "/users/facilitators")
    return response.data
  } catch (error) {
    return {
      success: false,
      error: "something went wrong"
    }
  }
}

export const blockFacilitatorById = async (id) => {
  try {
    const response = await axiosDefault.patch(API_URL + `/users/facilitators/${id}/block`)
    return response.data
  } catch (error) {
    return {
      success: false,
      error: "something went wrong"
    }
  }
}

export const getAssistants = async () => {
  try {
    const response = await axiosDefault.get(API_URL + "/users/assistants")
    return response.data
  } catch (error) {
    return {
      success: false,
      error: "something went wrong"
    }
  }
}



export const registerAssistant = async (data) => {
  try {
    const response = await axiosDefault.post(API_URL + "/users/assistants/register", data)
    return response.data
  } catch (error) {
    return {
      success: false,
      error: "something went wrong"
    }
  }
}

export const blockAssistantById = async (id) => {
  try {
    const response = await axiosDefault.patch(API_URL + `/users/assistants/${id}/block`)
    return response.data
  } catch (error) {
    return {
      success: false,
      error: "something went wrong"
    }
  }
}
